var _path, _circle, _circle2, _path2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.158L20 27.8419",
    stroke: "#5B5B5B",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.001,
    cy: 9.12246,
    r: 2.54153,
    stroke: "#EB5424",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.001,
    cy: 30.3716,
    r: 2.54153,
    stroke: "#EB5424",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37402 27.9117V20.9099C8.37402 19.8053 9.26945 18.9099 10.374 18.9099H29.5458C30.6504 18.9099 31.5458 19.8053 31.5458 20.9099V27.9117",
    stroke: "#5B5B5B",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4585,
    cy: 30.3716,
    r: 2.54153,
    stroke: "#EB5424",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.54153,
    cy: 30.3716,
    r: 2.54153,
    stroke: "#EB5424",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSso);
export default __webpack_public_path__ + "static/media/SSO.79dd14c3f3c5aa2e1cd47829ec241468.svg";
export { ForwardRef as ReactComponent };